import { SEARCH_SUBSCRIPTION_PLAN } from '../../../../temp/views/onboarding/PhotoSearchCheckout/helpers';

/**
 * Basically, allows you to code up features within the FE.
 * Comes in handy whenever you want to use the Feature API for a task that's not
 * particularly needed to be coded within GQL.
 *
 * Try to keep the naming similar to graphql here for consistency:
 * for example `some_feature_enabled`
 *
 * @param {Object} opts An object containing options.
 * @param {Object} opts.account The account to check permissions form.
 * @param {Array<Object>} opts.searchSubscriptionItems List of available search subscription plans.
 * @returns {{owned_content_free_joins_enabled: {plans: *[], enabled: boolean}}}
 */
export const useLocalFeatures = ({ account, searchSubscriptionItems = [] }) => {
  return {
    owned_content_free_joins_enabled: {
      enabled: !!account?.active_search_subscription,
      plans: searchSubscriptionItems.filter(item =>
        [SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PLUS].includes(item.plan),
      ),
    },
    expiration_disabled: {
      enabled: !!account?.active_search_subscription,
      plans: searchSubscriptionItems.filter(item =>
        [SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PLUS].includes(item.plan),
      ),
    },
    upload_limit_increase_enabled: {
      enabled: !!account?.active_search_subscription,
      plans: searchSubscriptionItems.filter(item =>
        [SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PLUS].includes(item.plan),
      ),
    },
  };
};
